// `Symbol.unscopables` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.unscopables
require('../internals/define-well-known-symbol')('unscopables');